import React from "react";


import ImagePartitionLayout from "../../layout/imagepartitionlayout/imagepartitionlayout";
import ChangePasswordForm from "./components/changepassswordform/changepasswordform";
import LoginForm from "../login/components/loginform";
import AuthenticationContainer from "../../components/AuthenticationContainer/authenticationcontainer";
import {CHNG_PASS_SUBTITLE, WEBSITE_TITLE} from "../../constants/appconstants";
class Login extends React.Component {
    render() {
        return (
            <ImagePartitionLayout ContentComponent={ <AuthenticationContainer  Component={<ChangePasswordForm/>}
                                                                               titleLabel={"Change Password"}/>}
                                  title={WEBSITE_TITLE}
                                  subtitle={
                                      ""}/>

        );
    }
}

export default Login;



